type SortDirection = 'asc' | 'desc';

export const toSortQuerystringParams = ({direction, column}: Sort) => ({
  sortOrder: direction,
  sortColumn: column,
});

export type Sort = {
  direction: SortDirection;
  column: string;
};
